import gql from 'graphql-tag'

export const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`

export const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`

export const GET_DEVICE_DETAILS = gql`
  query getAllAssignedDevicesToClient($clientId: Int!) {
    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {
      uniqueDeviceId
      deviceModel {
        model_name
      }
    }
  }
`

export const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int, $status: Int) {
    clientsDetails: allClientDetails(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      clientName
      loginId
      partner {
        businessName
      }
      zonalManager
      keyAccountManager
      channelPartnerName
    }
  }
`

export const GET_VLPN = gql`
  query checkVehicleNumber($vlpn: String!) {
    checkVehicleNumber(vehicleNumber: $vlpn)
  }
`

export const GET_SELECT_DEV_DETAILS = gql`
  query devicePartnerAssignDetail($uniqueId: String) {
    devicePartnerAssignDetail(uniqueDeviceId: $uniqueId) {
      deviceModel {
        id
        model_name
        devicetype
      }
      uniqueDeviceId
    }
  }
`

export const GET_SIM_DETAILS = gql`
  query getAllAssignedSimToClient($clientId: Int!) {
    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {
      id
      simId
      sim {
        phoneNumber
      }
    }
  }
`

export const GET_ACCESSORY_DETAILS = gql`
  query getAllAssignedAccessoryToClient($clientId: Int!) {
    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {
      accessory {
        uniqueAccessoryId
      }
    }
  }
`

export const GET_SELECT_PHONE_DETAILS = gql`
  query simPartnerAssignDetail($simId: Int) {
    simPartnerAssignDetail(simId: $simId) {
      sim {
        simNumber
      }
      serviceProvider {
        name
      }
    }
  }
`

export const GET_ZMKAM = gql`
  query getAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      username
      role
    }
  }
`

export const GET_DASHCAM_REGISTRATIONS = gql`
  query GetDashcamRegistrations {
    getDashcamRegistrations {
      success
      message
      data {
        uuid
        simid
        memorycardid
        uniqueid
        vtid
        status
        createdat
        updatedat
      }
    }
  }
`

export const GET_ALL_ASSIGNED_ROLES = gql`
  query GetAllAssignedRoles {
    getAllAssignedRoles {
      id
      uuid
      username
      email
      mobile_number
      role
      client_ids
      createdAt
      updatedAt
    }
  }
`

export const GET_RCS_INVENTORY = gql`
  query GetReverseCameraAndScreenInventory {
    getReverseCameraAndScreenInventory {
      data {
        rcs_serial_number
      }
    }
  }
`

export const UPDATE_RCS_INVENTORY = gql`
  mutation updateReverseCameraAndScreenInventory($rcsSerialNumber: String!, $input: UpdateReverseCameraAndScreenInventoryInput!) {
    updateReverseCameraAndScreenInventory(rcs_serial_number: $rcsSerialNumber, input: $input) {
      success
      message
    }
  }
`

export const ADD_VEHICLE = gql`
  mutation addVehicleDetail(
    $rcsSerialNumber: String
    $vehicleNumber: String!
    $engineNumber: String
    $chassisNumber: String
    $clientLoginId: Int!
    $uniqueDeviceId: String!
    $simId: Int!
    $speedSensorType: String!
    $speedLimit: Int!
    $uniqueAccessoryId: String
    $vehicleType: String
    $vehicleMake: String
    $averageMileage: Int
    $vehicleModel: String!
    $vehicleCapacity: Int
    $isActivated: Boolean
    $partnerSubscriptionId: Int!
    $accountType: String
    $vehicleIdentificationNumber: String
    $vehicleColour: String
    $invoiceNumber: String
    $idlingSpeed: Int
    $equipmentSerialNumber: String
    $equipmentName: String
    $commissioningDate: Int
    $invoiceDate: Int
    $department: String
    $contractorName: String
    $operatorName: String
    $operatorContactNumber: String
    $engineTorque: String
    $engineLoad: String
    $fuelType: String
    $torquePower: String
    $engineSpecification: String
    $emissionRateType: String
    $vehicleMakeId: String
    $vehicleModelId: String
    $grossVehicleWeight: Float
    $manufacturingYear: Int
    $vehicleSegment: String
    $equipmentTypeClass: String
    $constructionVehicleType: String
    $passengerVehicleType: String
    $transportationVehicleType: String
    $vehicleNickName: String
    $haulageType: String
    $vehicleWheeler: String
    $application: String
    $documentUpload: String
    $documentUploadNew: JSON
    $baselineDataForFE: Float
    $baselineDataType: String
    $baselineDataHour: Float
    $baselineDataForFELPH: Float
    $fuelTankCapacity: String
    $noOfGears: Int
    $gearRatio: String
    $adblueCapacity: String
    $vehicleRegistrationNumber: String
    $registrationDate: String
    $registrationValidUpto: String
    $stateCode: String
    $rtoCode: String
    $vehicleCategoryCode: String
    $vehicleCategoryDescription: String
    $vehicleClassDescription: String
    $makerDescription: String
    $makerModel: String
    $bodyTypeDescription: String
    $emissionNormsDescription: String
    $fitmentUpto: String
    $nationalPermitUpto: String
    $taxUpto: String
    $insurerName: String
    $insuranceUpto: String
    $manufacturingMonthYear: String
    $unladenWeight: Int
    $registeredAt: String
    $puccUpto: String
    $permitNumber: String
    $permitIssueDate: String
    $permitValidFrom: String
    $permitValidUpto: String
    $permitType: String
    $permitCode: String
    $numberOfAxles: Int
    $fuelCode: String
    $vehicleClass: String
    $baselineDistance: Float
    $immobilize: Boolean
    $solutionType: String
    $solution_type: [String]
    $isDualEngine: Boolean
    $eoff_voltage: Float
    $eon_voltage: Float
    $zonalManager: String
    $keyAccountManager: String
    $channelPartnerName: String
    $duplicateVehicle: Boolean
    $portedVehicle: Boolean
    $isTestingVehicle: Boolean
    $hasArm: Boolean
    $isElockConnection: Boolean
    $kvaRating: String
    $dgSetType: String
    $bhp: String
    $phase: String
    $engineModel: String
    $gensetController: String
    $videoTelematicsType: String
    $videoTelematicsId: String
    $inputParameter: Float
    $multiplicationFactor: Float
    $engineOnHours: String
    $odometerDistance: String
    $clientName: String!
    $custCode: String
    $custType: String
    $noOfWheels: Int
    $baselineHours: Int
    $isIndividualViewOrCombinedView: Boolean
    $vehicleCustomizedBodyType: String
    $tensionerConductorLength: Float
    $tensionerRotationSensorDirection: String
    $isRotationSensor: Boolean
    $technicianName: String
    $createdBy: String
    $istachoenabled: Boolean
    $tachoidlerpm: Int
    $tachoshifthours: Int
    $tachoengineonmin: Int
    $tachoengineonmax: Int
  ) {
    addVehicleDetail(
      rcsSerialNumber: $rcsSerialNumber
      vehicleNumber: $vehicleNumber
      engineNumber: $engineNumber
      chassisNumber: $chassisNumber
      clientLoginId: $clientLoginId
      uniqueDeviceId: $uniqueDeviceId
      simId: $simId
      speedSensorType: $speedSensorType
      speedLimit: $speedLimit
      uniqueAccessoryId: $uniqueAccessoryId
      vehicleType: $vehicleType
      vehicleMake: $vehicleMake
      averageMileage: $averageMileage
      vehicleModel: $vehicleModel
      vehicleCapacity: $vehicleCapacity
      isActivated: $isActivated
      partnerSubscriptionId: $partnerSubscriptionId
      accountType: $accountType
      vehicleIdentificationNumber: $vehicleIdentificationNumber
      vehicleColour: $vehicleColour
      invoiceNumber: $invoiceNumber
      idlingSpeed: $idlingSpeed
      equipmentSerialNumber: $equipmentSerialNumber
      equipmentName: $equipmentName
      commissioningDate: $commissioningDate
      invoiceDate: $invoiceDate
      department: $department
      contractorName: $contractorName
      operatorName: $operatorName
      operatorContactNumber: $operatorContactNumber
      engineTorque: $engineTorque
      engineLoad: $engineLoad
      fuelType: $fuelType
      torquePower: $torquePower
      engineSpecification: $engineSpecification
      emissionRateType: $emissionRateType
      vehicleMakeId: $vehicleMakeId
      vehicleModelId: $vehicleModelId
      grossVehicleWeight: $grossVehicleWeight
      manufacturingYear: $manufacturingYear
      vehicleSegment: $vehicleSegment
      equipmentTypeClass: $equipmentTypeClass
      constructionVehicleType: $constructionVehicleType
      passengerVehicleType: $passengerVehicleType
      transportationVehicleType: $transportationVehicleType
      vehicleNickName: $vehicleNickName
      haulageType: $haulageType
      vehicleWheeler: $vehicleWheeler
      application: $application
      documentUpload: $documentUpload
      documentUploadNew: $documentUploadNew
      baselineDataForFE: $baselineDataForFE
      baselineDataType: $baselineDataType
      baselineDataHour: $baselineDataHour
      baselineDataForFELPH: $baselineDataForFELPH
      fuelTankCapacity: $fuelTankCapacity
      noOfGears: $noOfGears
      gearRatio: $gearRatio
      adblueCapacity: $adblueCapacity

      vehicleRegistrationNumber: $vehicleRegistrationNumber
      registrationDate: $registrationDate
      registrationValidUpto: $registrationValidUpto
      stateCode: $stateCode
      rtoCode: $rtoCode
      vehicleCategoryCode: $vehicleCategoryCode
      vehicleCategoryDescription: $vehicleCategoryDescription
      vehicleClassDescription: $vehicleClassDescription
      makerDescription: $makerDescription
      makerModel: $makerModel
      bodyTypeDescription: $bodyTypeDescription
      emissionNormsDescription: $emissionNormsDescription
      fitmentUpto: $fitmentUpto
      nationalPermitUpto: $nationalPermitUpto
      taxUpto: $taxUpto
      insurerName: $insurerName
      insuranceUpto: $insuranceUpto
      manufacturingMonthYear: $manufacturingMonthYear
      unladenWeight: $unladenWeight
      registeredAt: $registeredAt
      puccUpto: $puccUpto
      permitNumber: $permitNumber
      permitIssueDate: $permitIssueDate
      permitValidFrom: $permitValidFrom
      permitValidUpto: $permitValidUpto
      permitType: $permitType
      permitCode: $permitCode
      numberOfAxles: $numberOfAxles
      fuelCode: $fuelCode
      vehicleClass: $vehicleClass

      baselineDistance: $baselineDistance
      immobilize: $immobilize
      solutionType: $solutionType
      solution_type: $solution_type
      isDualEngine: $isDualEngine
      eoff_voltage: $eoff_voltage
      eon_voltage: $eon_voltage
      zonalManager: $zonalManager
      keyAccountManager: $keyAccountManager
      channelPartnerName: $channelPartnerName
      duplicateVehicle: $duplicateVehicle
      portedVehicle: $portedVehicle
      isTestingVehicle: $isTestingVehicle
      hasArm: $hasArm
      isElockConnection: $isElockConnection
      kvaRating: $kvaRating
      dgSetType: $dgSetType
      bhp: $bhp
      phase: $phase
      engineModel: $engineModel
      gensetController: $gensetController
      videoTelematicsType: $videoTelematicsType
      videoTelematicsId: $videoTelematicsId
      inputParameter: $inputParameter
      multiplicationFactor: $multiplicationFactor

      engineOnHours: $engineOnHours
      odometerDistance: $odometerDistance

      technicianName: $technicianName
      createdBy: $createdBy

      clientName: $clientName
      custCode: $custCode
      custType: $custType
      noOfWheels: $noOfWheels
      baselineHours: $baselineHours
      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView
      vehicleCustomizedBodyType: $vehicleCustomizedBodyType
      tensionerConductorLength: $tensionerConductorLength
      tensionerRotationSensorDirection: $tensionerRotationSensorDirection
      isRotationSensor: $isRotationSensor
      istachoenabled: $istachoenabled
      tachoidlerpm: $tachoidlerpm
      tachoengineonmin: $tachoengineonmin
      tachoengineonmax: $tachoengineonmax
      tachoshifthours: $tachoshifthours
    )
  }
`

export const GET_CLIENT_DETAILS_BYID = gql`
  query clientDetail($clientId: Int!) {
    clientDetail(loginId: $clientId) {
      clientName
      id
      address
      city
      zonalManager
      keyAccountManager
      channelPartnerName
    }
  }
`

export const CHECK_ENGINE_NUMBER = gql`
  query checkEngineNumber($engineNumber: String!) {
    checkEngineNumber(engineNumber: $engineNumber)
  }
`

export const CHECK_CHASSIS_NUMBER = gql`
  query checkChassisNumber($chassisNumber: String!) {
    checkChassisNumber(chassisNumber: $chassisNumber)
  }
`

export const GET_SUBSCRIPTION_BY_PARTNERID = gql`
  query getAllPartnerSubscriptions(
    $partnerId: Int
    $deviceModelId: Int
    $status: [Int]
  ) {
    getAllPartnerSubscriptions(
      partnerLoginId: $partnerId
      deviceModelId: $deviceModelId
      status: $status
    ) {
      id
      deviceTrackingCharges
      totalSoftwareQty
    }
  }
`

export const GET_MAKE_AND_MODELS_MASTER = gql`
  query {
    getMakeAndModelMasterData {
      vehicleMake
      vehicleModel
      emissionRateType
    }
  }
`

export const GET_VEHICLE_MAKES = gql`
  query {
    getVehicleMakes {
      make
      id
    }
  }
`

export const GET_ALL_DG_MAKES = gql`
  query GetDgMakes {
    getDgMakes
  }
`

export const GET_DG_MODELS = gql`
  query GetDgModels($make: String!) {
    getDgModels(make: $make)
  }
`

export const GET_DG_SPECS_FROM_MODEL = gql`
  query GetDgSpecsFromModel($make: String!, $model: String!) {
    getDgspecsFromModel(make: $make, model: $model) {
      id
      make
      model
      kvaRating
      dgSetType
    }
  }
`

export const GET_VEHICLE_TYPE = gql`
  query getAllVehicleType {
    getAllVehicleType {
      vehicleTypeId
      vehicleType
    }
  }
`

export const GET_VEHICLE_MODELS = gql`
  query GetVehicleModels($makeId: String!) {
    getVehicleModels(makeId: $makeId) {
      id
      model
    }
  }
`

export const GET_VEHICLE_PARAMS = gql`
  query GetVehicleParameters($modelId: String!) {
    getVehicleParameters(modelId: $modelId) {
      id
      emission_type
      status
      model_id
      fuel_capacity
      adblue_capacity
      manufacturing_year
      fuel_type
      gross_vehicle_weight
      engine_specification
    }
  }
`

export const GET_VEHICLE_VAHAAN_DETAILS = gql`
  query GetVehicleVahaanDetails($vehicleNumber: String!) {
    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {
      id
      rcRegnNo
      rcRegnDt
      rcRegnUpto
      rcPurchaseDt
      rcOwnerSr
      rcOwnerName
      stateCd
      rtoCd
      rcPresentAddress
      rcPermanentAddress
      rcVchCatg
      rcVhClassDesc
      rcChasiNo
      rcEngNo
      rcMakerDesc
      rcMakerModel
      rcBodyTypeDesc
      rcFuelDesc
      rcColor
      rcNormsDesc
      rcFitUpto
      rcNpUpto
      rcNpIssuedBy
      rcTaxUpto
      rcFinancer
      rcInsuranceComp
      rcInsurancePolicyNo
      rcInsuranceUpto
      rcManuMonthYr
      rcUnldWt
      rcGvw
      rcNoCyl
      rcCubicCap
      rcSeatCap
      rcSleeperCap
      rcStandCap
      rcWheelbase
      rcRegisteredAt
      rcStatusAsOn
      rcPuccUpto
      rcPuccNo
      rcStatus
      rcNcrbStatus
      rcBlacklistStatus
      rcPermitNo
      rcPermitIssueDt
      rcPermitValidFrom
      rcPermitValidUpto
      rcPermitType
      rcPermitCode
      rcNocDetails
      rcVhType
      rcVhClass
      rcNocDt
      rcFuelCd
      rcMakerCd
      rcModelCd
      rcNormsCd
      rcSaleAmt
      rcOwnCatgDesc
      rcVhClassDesc
      rcOwnerCdDesc
      rcCurrentaddDistrictcode
      rcNonUse
      rcPassengerTax
      rcGoodsTax
      rcNoOfAxle
      rcApprovalDate
      rcHp
      rcMandalDesc
      rcTalukCd
    }
  }
`

export const GET_DROPDOWN_DETAILS = gql`
  query Query {
    getDropDownDetail
  }
`

export const GET_DROPDOWN_CATEGORIES = gql`
  query GetDropdownCategories {
    getDropdownCategories {
      category_name
      id
    }
  }
`

export const GET_DROPDOWN_VALUES_BY_CATEGORY = gql`
  query GetDropdownValuesByCategory($categoryId: ID) {
    getDropdownValuesByCategory(category_id: $categoryId) {
      value_name
    }
  }
`

export const GET_CUSTOMER_TYPE_AND_CODE = gql`
  query GetCustomerTypeAndCode($clientName: String!) {
    getCustomerTypeAndCode(clientName: $clientName) {
      id
      clientName
      registrationType
      directCustomerSAPCode
      channelPartnerSAPCode
    }
  }
`

export const GET_ALL_VEHICLES = gql`
  query getAllVehicleDetails($clientLoginId: Int) {
    getAllVehicleDetails(clientLoginId: $clientLoginId) {
      entityId
      vehicleNumber
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`

export const GET_CALIBRATION_DETAILS = gql`
  query getFuelCalibrationDetail($entityId: Int) {
    getFuelCalibrationDetail(vehicleId: $entityId) {
      fuelUserType
      fuelSensorType
      minTankCapacity
      minValue
      maxTankCapacity
      totalFuelTank
      maxValue
      pilferageTolerance
      calibration_filename
      url
      availableDataTypes
      preferedDataType
      hasSecondaryTank
      hasInSameTank
      isDualSensor
      useTaabiAlgo
      secondaryTankMinCapacity
      secondaryTankMaxCapacity
      secondaryTankTotalFuel
      secondaryTankMinValue
      secondaryTankMaxValue
      secondaryPolynomialEquation
      secondary_tank_calibration_filename
      secondaryUrl
      fuelSensorNames
      fuelSensorIMEIs
    }
  }
`

export const GET_CLIENT_DETAILS = gql`
  query clientDetail($loginId: Int) {
    clientDetail(loginId: $loginId) {
      id
      zone
      keyAccountManager
      litemode
      videoTelematicsType
      plan {
        id
        planName
      }
    }
  }
`

export const CONFIRM_VEHICLE_REGISTRATION = gql`
  mutation confirmVehicleRegistration($input: onboardingVehicleInput!) {
    confirmVehicleRegistration(input: $input) {
      success
      message
      vehicleId
    }
  }
`

export const GET_SOLUTION_TYPES = gql`
  query GetAllMasterSolutionType {
    getAllMasterSolutionType {
      id
      solutionTypeName
    }
  }
`

export const GET_SOLUTION_TYPES_WITH_PLANS = gql`
  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {
    getAllSolutionTypes(
      clientCategory: $clientCategory
      clientLoginId: $clientLoginId
    ) {
      id
      solution_type_name
      description
      solutionTypeCategory
      createdAt
      plans {
        id
        planName
        planTypeId
        durationInYears
        durationInMonths
        durationLabel
        description
        createdAt
        updatedAt
        status
        createdBy
        updatedBy
        clientLoginId
        basePrice
        discount
        clientCategory
        perMonthBaseValue
        perMonthDiscountedValue
        clientName
        isPopular
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/queries.jsx